import { render, staticRenderFns } from "./ListEducationalPost.vue?vue&type=template&id=2812d078&scoped=true&"
import script from "./ListEducationalPost.vue?vue&type=script&lang=js&"
export * from "./ListEducationalPost.vue?vue&type=script&lang=js&"
import style0 from "./ListEducationalPost.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ListEducationalPost.vue?vue&type=style&index=1&id=2812d078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812d078",
  null
  
)

export default component.exports